import {
  HomeOutlined,
  DashboardOutlined,
  AlertOutlined,
  NotificationOutlined,
  CameraOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { SidebarItem } from '_/components/common/layout/AppSidebar';
import { useDeliveryContext } from '_/contexts/DeliveryContext';
import { useFlowContext } from '_/contexts/FlowContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import { useProject } from '_/contexts/ProjectContext';
import React, { useMemo } from 'react';

// Create icon elements once to prevent re-renders
const homeIcon = <HomeOutlined />;
const dashboardIcon = <DashboardOutlined />;
const unorderedListIcon = <UnorderedListOutlined />;
const cameraIcon = <CameraOutlined />;
const notificationIcon = <NotificationOutlined />;
const alertIcon = <AlertOutlined />;

export function useDeliverySidebarItems(): SidebarItem[] {
  const { selectedOrgSlug } = useOrganization();
  const { selectedProjectSlug } = useProject();
  const { flowSlug } = useFlowContext();
  const { deliveryId } = useDeliveryContext();

  return useMemo(
    () => [
      {
        icon: homeIcon,
        text: 'Delivery Home',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/home`,
      },
      {
        icon: dashboardIcon,
        text: 'Dashboard',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/dashboard`,
      },
      {
        icon: unorderedListIcon,
        text: 'Snapshots',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/snapshots`,
      },
      {
        icon: cameraIcon,
        text: 'Snapshot Spotlight',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/snapshotspotlight`,
      },
      {
        icon: notificationIcon,
        text: 'Destination Pushes',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/destinationpushesspotlight`,
      },
      {
        icon: alertIcon,
        text: 'Alarms',
        href: `/orgs/${selectedOrgSlug}/projects/${selectedProjectSlug}/flows/${flowSlug}/deliveries/${deliveryId}/alarms`,
      },
    ],
    [selectedOrgSlug, selectedProjectSlug, flowSlug, deliveryId],
  );
}
